import { useEffect, useRef, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import {
  collection, getDocs, orderBy, limit, startAfter, query,
} from "firebase/firestore";
import { db, auth } from "../../../app/firebase";

import AdminFeedback from "./adminFeedback";

const PAGE_SIZE = 50;

export default function AdminFeedbackContainer() {
  const [checkingAdmin, setCheckingAdmin] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");

  const lastDocRef = useRef(null);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (user) => {
      setCheckingAdmin(true);
      setIsAdmin(false);
      if (!user) { setCheckingAdmin(false); return; }
      try {
        const token = await user.getIdTokenResult(true);
        setIsAdmin(!!token.claims.admin);
      } finally {
        setCheckingAdmin(false);
      }
    });
    return () => unsub();
  }, []);

  const makeBaseQuery = () =>
    query(collection(db, "feedback"), orderBy("createdAt", "desc"), limit(PAGE_SIZE));

  const loadFirstPage = async () => {
    if (!isAdmin || loading) return;
    setLoading(true); setError("");
    try {
      const snap = await getDocs(makeBaseQuery());
      const items = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
      lastDocRef.current = snap.docs[snap.docs.length - 1] || null;
      setRows(items);
      setDone(snap.docs.length < PAGE_SIZE);
    } catch (e) {
      setError(e.message || "Failed to load feedback");
    } finally { setLoading(false); }
  };

  const loadMore = async () => {
    if (!isAdmin || loading || done || !lastDocRef.current) return;
    setLoading(true); setError("");
    try {
      const base = query(
        collection(db, "feedback"),
        orderBy("createdAt", "desc"),
        startAfter(lastDocRef.current),
        limit(PAGE_SIZE)
      );
      const snap = await getDocs(base);
      const items = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
      lastDocRef.current = snap.docs[snap.docs.length - 1] || lastDocRef.current;
      setRows((prev) => [...prev, ...items]);
      if (snap.docs.length < PAGE_SIZE) setDone(true);
    } catch (e) {
      setError(e.message || "Failed to load more");
    } finally { setLoading(false); }
  };

  useEffect(() => { if (isAdmin) loadFirstPage(); }, [isAdmin]); // eslint-disable-line

  if (checkingAdmin) return <div style={{ padding: 16 }}>Проверяем права…</div>;
  if (!isAdmin) return <div style={{ padding: 16 }}>403 — доступ только для администраторов</div>;

  return (
    <AdminFeedback
      rows={rows}
      loading={loading}
      error={error}
      done={done}
      onRefresh={loadFirstPage}
      onLoadMore={loadMore}
    />
  );
}
